var map = {
	"./bouncing_marker_high.gif": 10877,
	"./bouncing_marker_high_DoB.gif": 22127,
	"./bouncing_marker_high_animal.gif": 20864,
	"./bouncing_marker_high_boat.gif": 99598,
	"./bouncing_marker_high_deformation.gif": 9754,
	"./bouncing_marker_high_electric-tower.gif": 51201,
	"./bouncing_marker_high_intrusion.gif": 68467,
	"./bouncing_marker_high_landslide.gif": 98350,
	"./bouncing_marker_high_leaks.gif": 80092,
	"./bouncing_marker_high_machinery.gif": 89468,
	"./bouncing_marker_high_manhole.gif": 69926,
	"./bouncing_marker_high_rock-falling.gif": 94217,
	"./bouncing_marker_high_submarine_impact.gif": 61581,
	"./bouncing_marker_high_temperature.gif": 57050,
	"./bouncing_marker_high_vehicle.gif": 89808,
	"./bouncing_marker_intermediate.gif": 20066,
	"./bouncing_marker_intermediate_DoB.gif": 38800,
	"./bouncing_marker_intermediate_animal.gif": 94921,
	"./bouncing_marker_intermediate_boat.gif": 91243,
	"./bouncing_marker_intermediate_deformation.gif": 15097,
	"./bouncing_marker_intermediate_electric-tower.gif": 74400,
	"./bouncing_marker_intermediate_intrusion.gif": 7744,
	"./bouncing_marker_intermediate_landslide.gif": 181,
	"./bouncing_marker_intermediate_leaks.gif": 49187,
	"./bouncing_marker_intermediate_machinery.gif": 68359,
	"./bouncing_marker_intermediate_manhole.gif": 65397,
	"./bouncing_marker_intermediate_rock-falling.gif": 32036,
	"./bouncing_marker_intermediate_submarine_impact.gif": 35364,
	"./bouncing_marker_intermediate_temperature.gif": 61473,
	"./bouncing_marker_intermediate_vehicle.gif": 26715,
	"./bouncing_marker_low.gif": 42857,
	"./bouncing_marker_low_DoB.gif": 93795,
	"./bouncing_marker_low_animal.gif": 50020,
	"./bouncing_marker_low_boat.gif": 66477,
	"./bouncing_marker_low_deformation.gif": 22830,
	"./bouncing_marker_low_electric-tower.gif": 29957,
	"./bouncing_marker_low_intrusion.gif": 9695,
	"./bouncing_marker_low_landslide.gif": 43218,
	"./bouncing_marker_low_leaks.gif": 88336,
	"./bouncing_marker_low_machinery.gif": 55800,
	"./bouncing_marker_low_manhole.gif": 22178,
	"./bouncing_marker_low_rock-falling.gif": 9789,
	"./bouncing_marker_low_submarine_impact.gif": 73345,
	"./bouncing_marker_low_temperature.gif": 70998,
	"./bouncing_marker_low_vehicle.gif": 48532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82960;